module.exports = __webpack_public_path__ + "img/puberty-decal-01.0efcfc69.png";